import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { VARIANT_ID, PRODUCT_PRICE, buildCheckoutUrl } from '../constants';
import { trackAddToCart } from '../utils/metaPixel';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  // VARIANT_ID & PRODUCT_PRICE are module-level constants; state setters are stable.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const addToCart = useCallback((qty, image) => {
    setItems(prev => {
      const existing = prev.find(i => i.variantId === VARIANT_ID);
      if (existing) {
        return prev.map(i =>
          i.variantId === VARIANT_ID ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [{
        variantId: VARIANT_ID,
        title: 'RELOAD Male Performance Formula',
        subtitle: '60 Capsules / 30-day supply',
        price: PRODUCT_PRICE,
        image,
        qty,
      }];
    });
    trackAddToCart(qty, PRODUCT_PRICE);
    setOpen(true);
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setQty = useCallback((variantId, qty) => {
    if (qty <= 0) {
      setItems(prev => prev.filter(i => i.variantId !== variantId));
    } else {
      setItems(prev =>
        prev.map(i => i.variantId === variantId ? { ...i, qty } : i)
      );
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const removeItem = useCallback((variantId) => {
    setItems(prev => prev.filter(i => i.variantId !== variantId));
  }, []);

  const totalQty = items.reduce((sum, i) => sum + i.qty, 0);
  const subtotal = items.reduce((sum, i) => sum + i.qty * i.price, 0);
  const checkoutUrl = items.length > 0 ? buildCheckoutUrl(totalQty) : '#';

  const value = useMemo(() => ({
    open, setOpen,
    items, addToCart, setQty, removeItem,
    totalQty, subtotal, checkoutUrl,
  }), [open, items, addToCart, setQty, removeItem, totalQty, subtotal, checkoutUrl]);

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
